module.exports = __webpack_public_path__ + "img/thermometer_black.25c61475.svg";